const pages = [
  { name: 'home', url: '/' },
  { name: 'about', url: '/about' },
  { name: 'why join?', url: '/join' },
  {
    name: 'promote',
    url: '/survey/promote',
    // submenu: [
    //   { name: 'referrer', url: '/survey/referrer' },
    //   { name: 'partners', url: '/survey/partner' },
    //   { name: 'affiliates', url: '/survey/affiliate' },
    // ],
  },
  // {
  //   name: 'graphs',
  //   url: '/resources/graphs',
  //   access: 'restricted',
  // },
  { name: 'resources', url: '/resources' },
  { name: 'blog', url: '/blog' },
  //{ name: 'resources', url: '/resources' },
  //{ name: 'reports', url: '/resources/reports' },
];

export default pages;
